// Data Schema for MoM Template
export const MOM_TEMPLATE = {
  title: "MoM Template",
  subtitle: "Meeting Minutes & Action Tracking",
  formTitle: "MoM Template (Make template form)",
  downloadFileName: "MoM_Template",
  downloadFileExtension: "png",
  sections: [
    {
      title: "Meeting Details",
      fields: [
        {
          label: "MoM ID",
          type: "text",
          placeholder: "Auto-generated by system",
          disabled: true,
        },
        {
          label: "Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured",
          disabled: true,
        },
        {
          label: "Meeting Type",
          type: "text",
          placeholder: "Enter meeting type",
        },
        {
          label: "Project / Facility Name",
          type: "text",
          placeholder: "Enter project or facility name",
        },
        {
          label: "Location / Platform",
          type: "text",
          placeholder: "Physical venue or digital platform",
        },
        {
          label: "Chairperson / Facilitator",
          type: "text",
          placeholder: "Name / Role",
        },
        {
          label: "Participants",
          type: "textarea",
          rows: 3,
          placeholder: "List of participants and their roles",
        },
        {
          label: "Agenda Items",
          type: "textarea",
          rows: 3,
          placeholder: "Pre-listed agenda items",
        },
      ],
    },
    {
      title: "Discussion Points (Multi-Entry Table)",
      type: "table",
      fields: [
        {
          label: "Agenda Item",
          type: "text",
          placeholder: "Item #1, Item #2, etc.",
          width: "15%",
        },
        {
          label: "Discussion Summary",
          type: "textarea",
          placeholder: "Summary of discussion",
          width: "25%",
        },
        {
          label: "AI Auto-Summarized Notes (Optional)",
          type: "checkbox",
          options: ["AI-generated"],
          width: "15%",
        },
        {
          label: "Responsible Person",
          type: "text",
          placeholder: "Name",
          width: "15%",
        },
        {
          label: "Due Date",
          type: "date",
          placeholder: "YYYY-MM-DD",
          width: "12%",
        },
        {
          label: "Status",
          type: "checkbox",
          options: ["Open", "Closed", "Pending"],
          width: "18%",
        },
      ],
      defaultRows: 2,
      maxRows: 10,
      addRowLabel: "Add Discussion Point",
    },
    {
      title: "Decisions Made",
      fields: [
        {
          label: "Decision #1",
          type: "textarea",
          rows: 2,
          placeholder: "Describe decision made",
        },
        {
          label: "Decision #2",
          type: "textarea",
          rows: 2,
          placeholder: "Describe decision made",
        },
        {
          label: "Additional Decisions",
          type: "textarea",
          rows: 3,
          placeholder: "Any other decisions made",
        },
        {
          label: "AI Auto-Rephrase Decisions",
          type: "checkbox",
          options: ["Yes - Generate AI-rephrased summary", "No - Manual review only"],
        },
        {
          label: "AI Rephrased Decisions",
          type: "textarea",
          rows: 3,
          placeholder: "AI-generated rephrased decisions will appear here",
          disabled: true,
        },
      ],
    },
    {
      title: "Action Items / Follow-Ups",
      type: "table",
      fields: [
        {
          label: "Action Item",
          type: "textarea",
          placeholder: "Describe action required",
          width: "25%",
        },
        {
          label: "Assigned To",
          type: "text",
          placeholder: "Name / Role",
          width: "18%",
        },
        {
          label: "Timeline",
          type: "date",
          placeholder: "Due date",
          width: "15%",
        },
        {
          label: "AI Suggested Action (Optional)",
          type: "checkbox",
          options: ["AI-generated"],
          width: "15%",
        },
        {
          label: "Status",
          type: "checkbox",
          options: ["Open", "In-Progress", "Completed"],
          width: "27%",
        },
      ],
      defaultRows: 2,
      maxRows: 10,
      addRowLabel: "Add Action Item",
    },
    {
      title: "Compliance / ESG Reference (Optional)",
      fields: [
        {
          label: "AI Auto-Link to applicable ESG Standards / Compliance Areas",
          type: "textarea",
          rows: 3,
          placeholder: "Auto-linked ESG Standards and Compliance references will appear here",
          disabled: true,
        },
        {
          label: "Manual Compliance References",
          type: "textarea",
          rows: 3,
          placeholder: "Enter any applicable compliance or ESG references",
        },
      ],
    },
    {
      title: "Meeting Confirmation & Submission",
      fields: [
        {
          label: "I confirm that all meeting information is accurate and complete:",
          type: "radio",
          options: ["Yes", "No"],
        },
        {
          label: "Additional Comments or Notes:",
          type: "textarea",
          rows: 3,
          placeholder: "Any additional context or observations",
        },
        {
          label: "Prepared By (Name & Title)",
          type: "text",
          placeholder: "Full name and title of person preparing MoM",
        },
        {
          label: "Prepared By Email",
          type: "email",
          placeholder: "Contact email for follow-up",
        },
        {
          label: "Submission Date & Time",
          type: "datetime-local",
          placeholder: "Auto-captured on submission",
          disabled: true,
        },
        {
          label: "Digital Signature",
          type: "text",
          placeholder: "Digital signature or typed signature confirmation",
        },
      ],
    },
  ],
};

// Reusable MoM Data - Can be passed as a key
export const MOM_TEMPLATES = {
  STANDARD: MOM_TEMPLATE,
  KICK_OFF: {
    ...MOM_TEMPLATE,
    title: "Download Kick-off Meeting Minutes",
    subtitle: "Project Kick-off Meeting Documentation",
  },
  PROGRESS_REVIEW: {
    ...MOM_TEMPLATE,
    title: "Download Progress Review Meeting Minutes",
    subtitle: "Progress Review Meeting Documentation",
  },
  COMPLIANCE: {
    ...MOM_TEMPLATE,
    title: "Download Compliance Meeting Minutes",
    subtitle: "Compliance Review Meeting Documentation",
  },
  CONTRACTOR: {
    ...MOM_TEMPLATE,
    title: "Download Contractor Meeting Minutes",
    subtitle: "Contractor Coordination Meeting Documentation",
  },
  STAKEHOLDER: {
    ...MOM_TEMPLATE,
    title: "Download Stakeholder Meeting Minutes",
    subtitle: "Stakeholder Engagement Meeting Documentation",
  },
};// src/config/SmartTemplateData.js

export const HIRA_JSA_BASE_TEMPLATE = {
  title: "Smart AI-Enabled Hazard Identification (HIRA/JSA) Template",
  subtitle: "",
  formTitle: "HIRA / JSA",
  downloadFileName: "HIRA_JSA_Report",
  downloadFileExtension: "pdf",

  sections: [
    // ====================== 1. BASIC INFO ======================
    {
      title: "Basic Information",
      fields: [
        { label: "Form ID", type: "text", value: "HIRA-2025-11-007", disabled: true },
        { label: "Date & Time", type: "datetime-local", value: "2025-11-26T09:30", disabled: true },
        { label: "Facility / Project Name", type: "text", value: "ABC Steel Plant, Raipur", required: true },
        { label: "Work Area / Location (Geo-tagged)", type: "text", value: "Workshop Bay 3 (28.7041° N, 77.1025° E)", disabled: true },
        { label: "Activity / Job Title", type: "text", value: "Metal Fabrication & Welding", required: true },
        { label: "Prepared By (User ID)", type: "text", value: "EHS-1024 (Rajesh Kumar)", disabled: true },
        { label: "Team Members (Optional)", type: "text", value: "Priya Sharma, Anil Mehta, 3 Contractors" }
      ]
    },

    // ====================== 2. MAIN TABLE – AB DATA DIKHEGA 100% ======================
    {
      title: "Hazard Identification & Risk Assessment",
      type: "table",
      addRowLabel: "+ Add New Task / Hazard",

      // Yeh fields define karte hain columns
      fields: [
        { label: "Task / Step", type: "text", required: true, width: "12%" },
        { label: "Hazard Identified", type: "textarea", rows: 3, required: true, width: "14%" },
        { label: "Consequence (Impact)", type: "textarea", rows: 3, required: true, width: "14%" },
        { label: "Likelihood (AI Optional)", type: "text", disabled: true, width: "10%" },
        { label: "Risk Rating (L × C)", type: "text", disabled: true, width: "10%" },
        { label: "Existing Controls", type: "textarea", rows: 3, required: true, width: "14%" },
        { label: "Additional Controls Required (AI Suggested)", type: "textarea", rows: 3, width: "16%" },
        { label: "Responsible Person", type: "text", required: true, width: "10%" },
        { 
          label: "Timeline", 
          type: "select", 
          options: ["Immediate", "Short-term", "Long-term"],
          required: true,
          width: "10%"
        },
        { 
          label: "Status", 
          type: "radio", 
          options: ["Open", "Closed"], 
          inline: true,
          width: "8%"
        }
      ],

      // Yeh preFilledRows se data load hoga
      preFilledRows: [
        {
          "Task / Step": "Cutting metal sheets",
          "Hazard Identified": "Flying sparks / eye injury",
          "Consequence (Impact)": "Minor to severe eye injury, fire risk",
          "Likelihood (AI Optional)": "Medium",
          "Risk Rating (L × C)": "High",
          "Existing Controls": "PPE (safety glasses, face shield)",
          "Additional Controls Required (AI Suggested)": "Install spark guards, enforce barricading, use fire blanket",
          "Responsible Person": "Supervisor",
          "Timeline": "Immediate",
          "Status": "Open"
        },
        {
          "Task / Step": "Welding in confined area",
          "Hazard Identified": "Fumes / toxic gases accumulation",
          "Consequence (Impact)": "Respiratory illness, asphyxiation, fire/explosion",
          "Likelihood (AI Optional)": "High",
          "Risk Rating (L × C)": "Critical",
          "Existing Controls": "Ventilation, PPE (respirator), hot work permit",
          "Additional Controls Required (AI Suggested)": "Add forced exhaust fans, install gas detector with AI alarm, continuous monitoring",
          "Responsible Person": "Contractor Lead",
          "Timeline": "Short-term",
          "Status": "Open"
        }
      ]
    },

    // ====================== 3. REMARKS & FOLLOW-UP ======================
    {
      title: "Remarks & Follow-Up",
      fields: [
        {
          label: "Summary of Key Hazards Identified",
          type: "textarea",
          rows: 6,
          value: "• High risk from flying sparks during cutting\n• Critical risk from fume accumulation in welding\n• AI detected lack of real-time gas monitoring\n• Immediate action required on exhaust systems",
          disabled: true
        },
        {
          label: "Overall Risk Profile (AI-Generated)",
          type: "text",
          value: "Critical – Immediate action required",
          disabled: true
        },
        {
          label: "Review Frequency",
          type: "select",
          options: ["Daily", "Weekly", "Monthly", "Task Completion"],
          value: "Weekly"
        }
      ]
    },

    // ====================== 4. DIGITAL SIGNATURES ======================
    {
      title: "E-Signature (Audit Ready)",
      fields: [
        { label: "Assessor", type: "text", value: "Rajesh Kumar", required: true },
        { label: "Supervisor", type: "text", placeholder: "___________________________", required: true },
        { label: "EHS Manager", type: "text", placeholder: "___________________________" },
        { label: "Date", type: "date", value: "2025-11-26", disabled: true }
      ]
    }
  ]
};


// ... baaki saare exports upar hain ...

// YE WAALA ADD KAR DO (sabse neeche ya kahin bhi)
export const ESG_REPORTING_COMPLIANCE_FORM_S3 = [
  {
    isFormSection: true,
    heading: "Auto-Synced to ESG Vision Dashboard",
    fields: []
  },
  {
    heading: "Detail Reporting",
    items: [
      { id: "detail_reporting", label: "Detail Reporting" }
    ]
  },
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" }
    ]
  },
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg_emissions", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      { id: "sustainable_finance", label: "Sustainable Finance & Bond Standards" },
      { id: "carbon_credit", label: "Carbon Credit, Offset & Emission Trading" }
    ]
  },
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" }
    ]
  },
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" }
    ]
  },
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" }
    ]
  },
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" }
    ]
  },
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" }
    ]
  }
];



export const ESG_REPORTING_STANDARDS_SELECTION = [
  // TOP BANNER – Auto-Synced Message (Recommended – bilkul top pe dikhega)
  {
    isFormSection: true,
    heading: "Auto-Synced to ESG Vision Dashboard",
    fields: [] // sirf heading dikhegi, koi field nahi
  },

  // DETAIL REPORTING – Sabse pehla checkbox
  {
    heading: "Detail Reporting",
    items: [
      { id: "detail_reporting", label: "Detail Reporting" }
    ]
  },

  // GLOBAL ESG REPORTING
  {
    heading: "Global ESG Reporting (Standards & Frameworks Compliances)",
    items: [
      { id: "gri", label: "GRI" },
      { id: "sasb", label: "SASB" },
      { id: "tcfd", label: "TCFD" },
      { id: "ifrs", label: "IFRS (S1, S2)" },
      { id: "csrd", label: "CSRD / ESRS (EU)" },
      { id: "ungc", label: "UNGC" },
      { id: "sdg", label: "SDG" },
      { id: "cdp", label: "CDP" },
      { id: "wb", label: "WB" },
      { id: "ifc", label: "IFC PSs" },
      { id: "equator", label: "Equator Principles" },
      { id: "iso", label: "ISO Standards" },
      { id: "oecd", label: "OECD Guidelines" },
      { id: "tnfd", label: "TNFD" },
      { id: "aa1000", label: "AA1000 Series" },
      { id: "pri", label: "PRI Principles" },
      { id: "iris", label: "IRIS+ (GIIN)" }
    ]
  },

  // CLIMATE & CARBON
  {
    heading: "Climate & Carbon Compliance",
    items: [
      { id: "ghg", label: "GHG Emissions Management" },
      { id: "climate_impact", label: "Climate Impact Assessment" },
      { id: "sustainable_finance", label: "Sustainable Finance & Bond Standards" },
      { id: "carbon_credit", label: "Carbon Credit, Offset & Emission Trading" }
    ]
  },

  // OPERATIONAL ESG
  {
    heading: "Operational ESG Systems & Reporting",
    items: [
      { id: "env_reporting", label: "Environmental Compliance Reporting" },
      { id: "social_reporting", label: "Social Compliance Reporting" },
      { id: "es_legal", label: "E&S Legal & Applicable Standards Mapping" },
      { id: "es_system", label: "Environmental & Social System Management" }
    ]
  },

  // INDUSTRIAL & COUNTRY-SPECIFIC
  {
    heading: "Industrial & Country-Specific ESG Compliance",
    items: [
      { id: "sector_std", label: "Sector / Industrial-Specific Standard" },
      { id: "country_std", label: "Country-Specific ESG Compliance" },
      { id: "operational_esg", label: "Operational Compliance ESG Reporting" },
      { id: "es_due", label: "E&S Due Diligence for ESG Compliance" }
    ]
  },

  // DATA ANALYTICS
  {
    heading: "Data Analytics",
    items: [
      { id: "esg_analytics", label: "ESG Analytics" },
      { id: "benchmarking", label: "ESG Benchmarking" }
    ]
  },

  // SUPPLIER
  {
    heading: "Supplier Selection & Compliance",
    items: [
      { id: "supplier_assessment", label: "Supplier Assessment & Compliance" }
    ]
  },

  // CAPACITY & FUTURE
  {
    heading: "Capacity & Future Development",
    items: [
      { id: "training", label: "Training & Capacity Building Programs" },
      { id: "upcoming", label: "Upcoming Features" }
    ]
  }
];
// ============================= FINAL EXPORT – MOM_TEMPLATES STYLE =============================

export const HIRA_JSA_TEMPLATES = {
  STANDARD: {
    ...HIRA_JSA_BASE_TEMPLATE,
    title: "Download HIRA / JSA Assessment Report",
    subtitle: "Full AI-Enabled Hazard Identification & Risk Assessment",
    downloadTitle: "HIRA_JSA_Full_Report"
  },

  TAKE5: {
    ...HIRA_JSA_BASE_TEMPLATE,
    title: "Download Take-5 Quick Safety Check",
    subtitle: "Fast Pre-Task Hazard Assessment (Take-5)",
    downloadTitle: "Take5_Safety_Check"
  },

  DAILY_HIRA: {
    ...HIRA_JSA_BASE_TEMPLATE,
    title: "Download Daily HIRA Log",
    subtitle: "Daily Site Hazard Identification Record",
    downloadTitle: "Daily_HIRA_Log"
  },

  CONTRACTOR_JSA: {
    ...HIRA_JSA_BASE_TEMPLATE,
    title: "Download Contractor JSA Submission",
    subtitle: "Contractor Job Safety Analysis with AI Review",
    downloadTitle: "Contractor_JSA_Submission"
  },

  HIGH_RISK_HIRA: {
    ...HIRA_JSA_BASE_TEMPLATE,
    title: "Download High-Risk Activity HIRA",
    subtitle: "Confined Space • Hot Work • Height Work • LOTO",
    downloadTitle: "HighRisk_HIRA_Report"
  },

  ESG_COMPLIANCE: {
    ...HIRA_JSA_BASE_TEMPLATE,
    title: "Download ESG-Linked HIRA Report",
    subtitle: "Direct sync to ESG & Compliance Dashboard",
    downloadTitle: "HIRA_ESG_Compliance_Report"
  }
};




export const ENVIRONMENTAL_MONITORING_AI_BASE_TEMPLATE = {
  // Header Buttons – adapted from reference
  topRightButtons: ["Countdown Timer", "SAVE", "USER ID"],
  bottomButtons: ["NEXT"],
  actionButtons: [
    { icon: "Download filled MoM Report", label: "Download filled Environmental Monitoring Report" },
    { icon: "Synchronize with ESG Reporting Dashboard", label: "Sync to ESG Dashboard" }
  ],

  title: "Smart AI-Enabled Environmental Monitoring Template",
  subtitle: "AI-powered real-time environmental parameter detection & compliance assessment",
  formTitle: "Environmental Monitoring Report",
  downloadTitle: "Environmental_Monitoring_Report",

  sections: [
    // ====================== 1. BASIC INFO ======================
    {
      title: "Basic Information",
      fields: [
        { label: "Monitoring ID", type: "text", placeholder: "Auto-generated unique identifier", disabled: true },
        { label: "Date & Time", type: "datetime-local", placeholder: "Auto-captured (with timezone)", disabled: true },
        { label: "Facility / Project Name", type: "text", placeholder: "_________________________", required: true },
        { label: "Monitoring Area(s)", type: "text", placeholder: "Multiple zones/sections within site (multi-select with AI auto-suggestions)", required: true },
        { label: "Geo-Tagging", type: "text", placeholder: "GPS auto-captured", disabled: true },
        { label: "Monitoring Team", type: "text", placeholder: "Names/Roles (EHS, ESG, Contractors, Consultants)" }
      ]
    },

    // ====================== 2. MAIN TABLE ======================
    {
      title: "Parameter Monitoring & Compliance Assessment",
      type: "table",
      addRowLabel: "+ Add New Parameter Monitoring",
      columns: [
        { key: "parameter",    label: "Parameter Monitored",         type: "text",     required: true,  placeholder: "e.g., PM2.5 (Air)" },
        { key: "standard",     label: "Standard / Benchmark",        type: "text",     required: true,  placeholder: "e.g., WHO ≤ 25 µg/m³" },
        { key: "method",       label: "Method / Equipment",          type: "text",     required: true,  placeholder: "e.g., Portable Air Sampler" },
        { key: "measuredValue",label: "Measured Value",              type: "number",   required: true },
        { key: "unit",         label: "Unit",                        type: "text",     required: true,  placeholder: "e.g., µg/m³" },
        { key: "complianceStatus", label: "Compliance Status (AI Auto-check)", type: "text", disabled: true, placeholder: "✅ Compliant / ❌ Non-Compliant" },
        { key: "variance",     label: "Variance from Standard",      type: "text",     disabled: true, placeholder: "e.g., +13 µg/m³" },
        { key: "aiAction",     label: "AI Suggested Action",         type: "textarea", required: true,  rows: 3, note: "AI suggests corrective actions" },
        { key: "responsible",  label: "Responsible Person",          type: "text",     required: true },
        { key: "timeline",     label: "Timeline",                    type: "select",   required: true,  options: ["Immediate", "1 Week", "Ongoing"] },
        { key: "status",       label: "Status",                      type: "radio",    options: ["Open", "Closed"], default: "Open" }
      ],

      // SAMPLE ROWS – based on provided examples
      sampleRows: [
        {
          parameter: "PM2.5 (Air)",
          standard: "WHO ≤ 25 µg/m³",
          method: "Portable Air Sampler",
          measuredValue: 38,
          unit: "µg/m³",
          complianceStatus: "❌ Non-Compliant",
          variance: "+13 µg/m³",
          aiAction: "Dust suppression, contractor oversight",
          responsible: "EHS Officer",
          timeline: "Immediate",
          status: "Open"
        },
        {
          parameter: "Noise Level",
          standard: "OSHA ≤ 85 dB",
          method: "Sound Meter",
          measuredValue: 92,
          unit: "dB",
          complianceStatus: "❌ Non-Compliant",
          variance: "+7 dB",
          aiAction: "Install barriers, enforce PPE use",
          responsible: "Contractor Lead",
          timeline: "1 Week",
          status: "Open"
        },
        {
          parameter: "BOD (Water)",
          standard: "Local Std ≤ 30 mg/L",
          method: "Lab Analysis",
          measuredValue: 18,
          unit: "mg/L",
          complianceStatus: "✅ Compliant",
          variance: "Within limit",
          aiAction: "Maintain STP performance",
          responsible: "Utility Manager",
          timeline: "Ongoing",
          status: "Open"
        }
      ]
    },

    // ====================== 3. VALIDATION & CLOSURE ======================
    {
      title: "Validation & Closure",
      fields: [
        {
          label: "Cross-Linked Risks",
          type: "text",
          disabled: true,
          placeholder: "AI auto-links with Risk Register",
          note: "AI auto-links with Risk Register"
        },
        {
          label: "Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"],
          default: "Open"
        },
        { label: "Reviewed By", type: "text", placeholder: "Supervisor / EHS-ESG Officer / Compliance Lead", required: true },
        { label: "Review Date", type: "date", placeholder: "______________________", required: true }
      ]
    },

    // ====================== 4. CLOSING & SIGNATURES ======================
    {
      title: "Closing & Signatures (Audit Ready)",
      type: "signature",
      fields: [
        { label: "Prepared By (Monitoring Lead)", type: "signature", placeholder: "____________________", required: true },
        { label: "Verified By (EHS/ESG Officer)", type: "signature", placeholder: "____________________", required: true },
        { label: "Approved By (Project/Corporate ESG Lead)", type: "signature", placeholder: "____________________", required: true },
        { label: "Date", type: "date", placeholder: "____________________", required: true }
      ]
    }
  ]
};

// ============================= FINAL EXPORT – Similar to HIRA_JSA_TEMPLATES STYLE =============================








export const ENVIRONMENTAL_MONITORING_AI_TEMPLATES = {
  title: "AI-Generated Monitoring Table",
  subtitle: "Real-time Multi-Parameter Compliance | AI Auto-Check | Audit-Ready",
  formTitle: "Environmental Monitoring Log (Water | Air | Noise)",
  downloadFileName: "AI_Environmental_Monitoring_Report",
  downloadFileExtension: "png",

  sections: [
    // ========= 1. Monitoring Setup Information =========
    {
      title: "Monitoring Setup Information",
      fields: [
        { label: "Monitoring ID", type: "text", placeholder: "Auto-generated unique identifier", disabled: true },
        { label: "Date & Time", type: "datetime-local", placeholder: "Auto-captured (with timezone)", disabled: true },
        { label: "Facility / Project Name", type: "text", placeholder: "Enter facility or project name", required: true },
        {
          label: "Monitoring Area(s)",
          type: "checkbox",
          options: [
            "Raw Water Intake",
            "Process Area",
            "Cooling Tower",
            "ETP/STP Outlet",
            "Wastewater Discharge Point",
            "Air Emission Stack",
            "Noise Monitoring Zone",
            "Community Boundary",
            "Groundwater Well",
            "Ambient Air Station",
            "Other (specify)"
          ]
        },
        { label: "Geo-Tagging", type: "text", placeholder: "GPS auto-captured", disabled: true },
        { label: "Monitoring Team", type: "textarea", rows: 3, placeholder: "EHS, ESG, Contractors, Consultants (Names & Roles)" }
      ]
    },

    // ========= 2. AI-Powered Monitoring Results Table (WITH 3 PRE-FILLED EXAMPLES) =========
    {
      title: "Monitoring Results Table (AI Auto-Check & Suggested Actions)",
      type: "table",
      addRowLabel: "Add Parameter",
      defaultRows: 3,
      preFilledRows: [
        {
          "Parameter Monitored": "PM2.5 (Air)",
          "Standard / Benchmark": "WHO ≤ 25 µg/m³",
          "Method / Equipment": "Portable Air Sampler",
          "Measured Value": "38",
          "Unit": "µg/m³",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+13 µg/m³",
          "AI Suggested Action": "Dust suppression, contractor oversight",
          "Responsible Person": "EHS Officer",
          "Timeline": "Immediate",
          "Status": "Open"
        },
        {
          "Parameter Monitored": "Noise Level",
          "Standard / Benchmark": "OSHA ≤ 85 dB",
          "Method / Equipment": "Sound Meter",
          "Measured Value": "92",
          "Unit": "dB",
          "Compliance Status (AI)": "Non-Compliant",
          "Variance from Standard": "+7 dB",
          "AI Suggested Action": "Install barriers, enforce PPE use",
          "Responsible Person": "Contractor Lead",
          "Timeline": "1 Week",
          "Status": "Open"
        },
        {
          "Parameter Monitored": "BOD (Water)",
          "Standard / Benchmark": "Local Std ≤ 30 mg/L",
          "Method / Equipment": "Lab Analysis",
          "Measured Value": "18",
          "Unit": "mg/L",
          "Compliance Status (AI)": "Compliant",
          "Variance from Standard": "Within limit",
          "AI Suggested Action": "Maintain STP performance",
          "Responsible Person": "Utility Manager",
          "Timeline": "Ongoing",
          "Status": "Closed"
        }
      ],
      fields: [
        { label: "Parameter Monitored",       type: "text",      width: "14%", placeholder: "e.g., BOD, PM2.5, Noise" },
        { label: "Standard / Benchmark",      type: "text",      width: "15%", placeholder: "e.g., ≤30 mg/L, WHO ≤25 µg/m³" },
        { label: "Method / Equipment",        type: "text",      width: "13%", placeholder: "Lab, Sound Meter, Air Sampler" },
        { label: "Measured Value",            type: "text",      width: "10%" },
        { label: "Unit",                      type: "text",      width: "8%",  placeholder: "mg/L, µg/m³, dB" },
        { label: "Compliance Status (AI)",    type: "text",      disabled: true, placeholder: "Compliant / Non-Compliant", width: "10%" },
        { label: "Variance from Standard",    type: "text",      disabled: true, width: "10%" },
        { label: "AI Suggested Action",       type: "text",      disabled: true, width: "16%" },
        { label: "Responsible Person",        type: "text",      width: "12%" },
        { label: "Timeline",                  type: "text",      width: "10%", placeholder: "Immediate, 1 Week, Ongoing" },
        { label: "Status",                    type: "radio",     options: ["Open", "Closed"], inline: true, width: "10%" }
      ]
    },

    // ========= 3. Validation & Closure =========
    {
      title: "Validation & Closure",
      fields: [
        {
          label: "Cross-Linked Risks (AI Auto-Detect)",
          type: "input",
          value: "PM2.5 exceedance → Risk ID: AIR-002 (Community Health Risk)\nNoise violation → Risk ID: SOC-007 (Community Complaint)",
          disabled: true
        },
        {
          label: "Monitoring Status",
          type: "radio",
          options: ["Open", "Under Review", "Resolved", "Verified"]
        },
        { label: "Reviewed By", type: "text", placeholder: "Supervisor / EHS-ESG Officer / Compliance Lead" },
        { label: "Review Date", type: "date" }
      ]
    },

    // ========= 4. Closing & Digital Signatures (Audit-Ready) =========
    {
      title: "Closing & Signatures (Audit Ready)",
      fields: [
        { label: "Prepared By (Monitoring Lead)", type: "text", placeholder: "Name & Designation", required: true },
        { label: "Verified By (EHS/ESG Officer)", type: "text", placeholder: "Name & Designation", required: true },
        { label: "Approved By (Project/Corporate ESG Lead)", type: "text", placeholder: "Name & Designation", required: true },
        { label: "Date", type: "date", disabled: true, placeholder: "Auto-filled on approval" },
        {
          label: "Final Confirmation",
          type: "checkbox",
          options: ["I confirm all monitoring data is accurate, actions assigned, and ready for ESG reporting"],
          required: true
        }
      ]
    }
  ]
};






